import * as actions from './deactivateUserActions';

const deactivateUserReducers = {
  [actions.USER_DEACTIVATE_USER_SUCCESS_RECEIVED]: state => {
    return state;
  },
};

export default deactivateUserReducers;
